import { Author } from './models';
import sebi from '../assets/images/authors/sebi.jpg';
import christian from '../assets/images/authors/christian.jpg';

export const AuthorMap: { [key in Author]: { link?: string; img: string } } = {
    [Author.HakanTanriverdi]: {
        link: 'https://www.br.de/nachrichten/autoren/hakan-tanriverdi,1ae9a583-47e1-45f9-abf1-84fa3ffcabc1',
        img:
            'https://img.br.de/49f5d09b-7df1-44c3-b16d-b23868453d02.jpeg?_v=1562931748898&rect=0%2C16%2C333%2C333&w=250'
    },
    [Author.SteffenKuehne]: {
        link: 'https://www.br.de/nachrichten/autoren/steffen-kuehne,a23634a8-d1bd-47ca-bc5a-bf605c53b6ca',
        img:
            'https://img.br.de/6ca9f7fc-1159-4838-b116-21568a9398b9.jpeg?_v=1589106187678&rect=169%2C380%2C841%2C842&w=250'
    },
    [Author.MaximilianZierer]: {
        link: 'https://www.br.de/nachrichten/autoren/maximilian-zierer,132f9263-fc49-47c5-8079-b0dc8a7d1ff5',
        img:
            'https://img.br.de/3ddda85a-d907-460e-aa2c-59a6c7fc0896.jpeg?rect=363%2C0%2C2189%2C2190&_v=1563449549524&w=250'
    },
    [Author.NielsRingler]: {
        link: 'https://www.br.de/nachrichten/autoren/niels-ringler,80b37cf0-c910-4817-a790-a76c0e09c60b',
        img:
            'https://img.br.de/f6945c06-bc22-4af3-a4e7-2cbbc75a7e97.jpeg?rect=217%2C0%2C812%2C812&_v=1575469041134&w=250'
    },
    [Author.RobertSchoeffel]: {
        link: 'https://www.br.de/nachrichten/autoren/robert-schoeffel,2c917903-4909-4206-8063-5c367e1b0e5f',
        img:
            'https://img.br.de/8a7859d2-4562-46f7-b499-3f76afd3ad21.jpeg?_v=1561638524053&rect=169%2C61%2C2135%2C2136&w=250'
    },
    [Author.UliKoeppen]: {
        link: 'https://www.br.de/nachrichten/autoren/uli-koeppen,20b49e8a-200e-49f1-a441-625a3e990986',
        img: 'https://img.br.de/7203e72b-e791-48e7-8eb2-b267716685d8.jpeg?_v=1589105808372&rect=471%2C0%2C591%2C592'
    },
    [Author.MichaelKreil]: {
        link: 'https://www.br.de/nachrichten/autoren/michael-kreil,249f2e9c-18bd-4f24-bfb2-146ca47237f4',
        img: 'https://img.br.de/5979250b-4fef-4b8d-9729-6f0a1314325e.png?_v=1589105944908&rect=161%2C105%2C576%2C576'
    },
    [Author.AnnKathrinWetter]: {
        link: 'https://www.br.de/nachrichten/autoren/ann-kathrin-wetter,3c940108-e1a5-47e2-93b4-a3286715dfc7',
        img:
            'https://img.br.de/cdd3d8cb-f097-45af-b6c9-845b32ecd98a.jpeg?_v=1581458173809&rect=1300%2C1297%2C1971%2C1971&w=250'
    },
    [Author.VerenaNierle]: {
        link: 'https://www.br.de/nachrichten/autoren/verena-nierle,16f57ef0-a6bc-4355-a239-07f8f9d42000',
        img: 'https://img.br.de/f4267c9c-2bb1-41f6-8a95-b49da441f898.jpeg?rect=664%2C24%2C683%2C684&_v=1578842580790'
    },
    [Author.LisaWreschniok]: {
        link: 'https://www.br.de/nachrichten/autoren/lisa-wreschniok,7544e03a-ec53-44ef-9c6a-04f4842f3873',
        img:
            'https://img.br.de/8548b1bb-5b2b-48c9-8205-92f024ef14f6.jpeg?rect=92%2C7%2C870%2C870&_v=1542145511388&w=250'
    },
    [Author.ElisaHarlan]: {
        link: 'https://www.br.de/nachrichten/autoren/elisa-harlan,64e79d78-4f71-43d2-85cf-a4db56c35cd7',
        img:
            'https://img.br.de/7003873d-e509-421b-bf1c-a70f38260880.jpeg?_v=1583268815408&rect=593%2C896%2C2430%2C2433&w=250'
    },
    [Author.OliverSchnuck]: {
        link: 'https://www.br.de/nachrichten/autoren/oliver-schnuck,fcc4d8dd-674c-4084-b745-2a1aa1412ad1',
        img: 'https://img.br.de/60ee470a-829d-4262-9afd-1bced919620f.jpeg?_v=1565419655297&rect=79%2C0%2C150%2C150'
    },
    [Author.SammyKhamis]: {
        link: 'https://www.br.de/nachrichten/autoren/sammy-khamis,6f9a224d-756b-491c-ade0-19c6a1dabcad',
        img: 'https://img.br.de/124db368-99b0-411e-9997-017d81ba8b44.jpeg?_v=1558381050870&rect=610%2C171%2C836%2C836'
    },
    [Author.RebeccaCiesielski]: {
        link: 'https://www.br.de/nachrichten/autoren/rebecca-ciesielski,5d7dd89a-f4c8-4977-81e7-ee4f4bfef1d1',
        img:
            'https://img.br.de/5dcd58aa-81ee-43e5-b6b5-c2798f8c2ad7.jpeg?_v=1605532649758&rect=226%2C0%2C1108%2C1108&w=250'
    },
    [Author.SebastianBayerl]: {
        img: sebi
    },
    [Author.ChristianSonnberger]: {
        img: christian
    }
};
